import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';
import { customValidationService } from 'src/app/shared/custom.validator';
@Component({
  selector: 'app-add-collection',
  templateUrl: './add-collection.component.html',
  styleUrls: ['./add-collection.component.scss'],
})
export class AddCollectionComponent implements OnInit, OnDestroy {
  // variable declaration
  timeZone: string;
  language: string;
  languagesData$: Subscription;
  timeZoneData$: Subscription;
  collectionPostData$: Subscription;
  languageArr = [];
  timeZoneArr = [];
  userForm: FormGroup;
  selectedValue: Number;
  selectedTimezone;

  constructor(
    private router: Router,
    private webErrorService: WebErrorService,
    private collectionService: CollectionService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<AddCollectionComponent>,
  ) { }

  ngOnInit(): void {
    this.languagesData$ = this.collectionService
      .getLanguages()
      ?.subscribe((languagesData: any) => {
        this.languageArr = languagesData?.items;
        this.selectedValue = 1;
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    this.timeZoneData$ = this.collectionService
      .getTimeZone()
      ?.subscribe((timeZoneData: any) => {
        this.timeZoneArr = timeZoneData?.items;
        this.selectedTimezone = 'Asia/Kolkata';
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    this.userForm = new FormGroup({
      collectionName: new FormControl(null, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]),
      description: new FormControl('', [
        Validators.minLength(1),
        Validators.maxLength(480),
      ]),
      langid: new FormControl('', [Validators.required]),
      timeZoneName: new FormControl('', [Validators.required]),
    });
  }

  // This function used for validation purpose
  get f(): any {
    return this.userForm.controls;
  }

  saveBtnFn(): void {
    if (this.userForm.value.description != null) {
      this.userForm.value.description = this.userForm.value.description.trim();
    } else {
      this.userForm.value.description = this.userForm.value.description;
    }
    const apiData = {
      collectionName: this.userForm.value.collectionName.trim(),
      description: this.userForm.value.description,
      langid: this.userForm.value.langid,
      timezoneName: this.userForm.value.timeZoneName,

    };
    this.collectionPostData$ = this.collectionService
      .postCollection(apiData)
      ?.subscribe(
        (resData) => {
          this.refershToken();
          this.notificationService.success(resData?.message);
          const id = JSON.stringify(resData?.data?.collectionuuId);
          sessionStorage.setItem('defaultcollectionuuid', id);
          sessionStorage.setItem('defaultcollectionid', resData?.data?.collectionid);
          this.dialogRef.close();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          this.userForm.controls['collectionName'].reset();
        }
      );
  }
  refershToken() {
    this.collectionService.refershToken()?.subscribe(resData => {
      this.collectionService.getCollection()?.subscribe(resData => {
        this.collectionService.newCollectionList(resData);
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
  }
  ngOnDestroy(): void {
    this.languagesData$?.unsubscribe();
    this.timeZoneData$?.unsubscribe();
    this.collectionPostData$?.unsubscribe();
  }
}
